<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001137')"
						paramKey="powLnCd"
						:options="powLnCdList"
						:propData="searchParams.powLnCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<select-combo
						:label="getMessage_('RCMS000093')"
						paramKey="insnRsltCd"
						:options="insnRsltCdList"
						:propData="searchParams.insnRsltCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC001390')">
						<el-date-picker
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							:value="searchParams.insnDd"
							@input="val => setParams(val, 'insnDd')"
						/>
					</sf-group-wrapper>
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001911')"
						paramKey="ipnNos"
						@commInput="setSearchParam"
						:filterReg="/[^-\.0-9]/g"
						:clearable="true"
						:propData="searchParams.ipnNos"
					>
					</search-input>
				</el-col>
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001216')"
						paramKey="insnCyclCd"
						:options="insnCyclCdList"
						:propData="searchParams.insnCyclCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/pqy/ptin/PowTourRgst/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		return {
			searchDate: ''
		};
	},
	components: { SelectCombo, SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				powLnCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001137')])),
				insnDd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001390')])),
				ipnNos: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001911')]))
			});
		}
	},
	methods: {
		...serviceMethods,
		setSearchParam({ key, value }) {
			if (key == 'ipnNos') {
				let numberRegEx = /[^0-9]/g; //숫자만 입력가능
				value = value.replace(numberRegEx, '');
				//console.log(value);
			}
			this.setSearchParam_({ key, value });
		},
		setParams(value, key) {
			this.setSearchParam_({ key, value });
		},
		async searchList() {
			try {
				const searchPar = this.searchParams;
				//벨리데이션체크
				this.insVali.validateSync(searchPar);
				this.$sf_toggleLoading(true);
				await this.getPowTourRgstManagements_();

				//조회가 끝난 후에 저장된 데이터는 자동으로 그리드 체크박스를 선택하도록 한다.
				this.$emit('selectChecks');
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	async created() {
		try {
			//라인 콤보
			await this.getCommCodes_({ key: 'powLnCdList', codeType: 'OCCU_PL' });

			//주기 콤보
			await this.getCommCodes_({ key: 'insnCyclCdList', codeType: 'INSN_CYCL' });

			//결과 콤보
			await this.getCommCodes_({ key: 'insnRsltCdList', codeType: 'INSN_RSLT' });

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
